import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LedgersService {

  selectedSkuFilter: any = null;

  constructor(private readonly http: HttpClient) { }

  getSkuLedgerData(payload: any) {
    let url = environment.BASE_URL + '/v1/ledger/sku';
    return this.http.get(url, { params: payload });
  }

  getSkuLedgersPdf(payload: any) {
    let url = environment.BASE_URL + '/v1/ledger/sku/download-pdf';
    return this.http.get(url, { params: payload, responseType: 'blob', observe: 'events', reportProgress: true });
  }

  getSkuLedgersExcel(payload: any) {
    let url = environment.BASE_URL + '/v1/ledger/sku/download-excel';
    return this.http.get(url, { params: payload, responseType: 'blob', observe: 'events', reportProgress: true });
  }

  getDealerSummary(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/buyer-history-summary';
    return this.http.get(url, { params: payload });
  }

  getSaleTrends(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/sales-trend-analysis';
    return this.http.get(url, { params: payload });
  }

  getPriceTrends(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/price-trend-analysis';
    return this.http.get(url, { params: payload });
  }

  getBuyerHistory(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/top-buyers';
    return this.http.get(url, { params: payload });
  }

  getBuyersHistoryCSV(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/top-buyers/download-csv';
    return this.http.get(url, { params: payload, responseType: 'blob', observe: 'events', reportProgress: true });
  }

  getDealersStopBuying(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/stop-buying';
    return this.http.get(url, { params: payload });
  }

  getDealerStopBuyingCSV(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/stop-buying/download-csv';
    return this.http.get(url, { params: payload, responseType: 'blob', observe: 'events', reportProgress: true });
  }

  getPerformanceHighlights(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/highlights';
    return this.http.get(url, { params: payload });
  }

  getClosingBalanceByBranch(payload: any) {
    let url = environment.BASE_URL + '/v1/company-stock/branch-wise-summary';
    return this.http.get(url, { params: payload });
  }

  getSaveValueByBranch(payload: any) {
    let url = environment.BASE_URL + '/v1/insights/branch-wise-stock-summary';
    return this.http.get(url, { params: payload });
  }

  getLatestTyreModels(params: any) {
    let url = environment.BASE_URL + '/v1/company-stock/unique-patterns';
    return this.http.get(url, { params: params });
  }

}
